import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-imeis-main",
    templateUrl: "./imeis.main.component.html",
    standalone: false
})
export class ImeisMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
